import { ReactNode } from 'react';

import { xCount } from '@/utils/stringUtils';

import { PAYMENT_PLAN_PRICING_MAP } from '../../utils/constants';
import {
  DeploymentUsageBasedPlanFeatureTextWithTooltip,
  TraceUsageBasedPlanFeatureTextWithTooltip,
} from '../UsageBasedPlanFeatureTextWithTooltip';
import { PaymentPlanCardTiers } from '../types';

export const formatter = new Intl.NumberFormat('en-US', {});
export const PLAN_INFOS: {
  [key in PaymentPlanCardTiers]: {
    planDesc: string;
    planFeatures: (string | ReactNode)[];
    planPriceHead: string;
    planPriceDesc: string;
  };
} = {
  developer: {
    planDesc: 'For solo developers getting started',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip
        planType="developer"
        showUsageCounter={true}
      />,
      '1 seat included',
    ],
    planPriceHead: 'Free',
    planPriceDesc: '',
  },
  plus: {
    planDesc: 'For teams building and deploying agents',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip planType="plus" />,
      'Up to 10 seats',
      <DeploymentUsageBasedPlanFeatureTextWithTooltip planType="plus" />,
      `${xCount(
        'Dev deployment',
        PAYMENT_PLAN_PRICING_MAP['plus'].lgpDevDeployments || 0
      )} with usage included`,
    ],
    planPriceHead: `$${PAYMENT_PLAN_PRICING_MAP['plus'].pricePerSeat}`,
    planPriceDesc: '/ seat per month',
  },
  startup: {
    planDesc: 'For small teams starting to build and deploy agents',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip planType="startup" />,
      'Up to 10 seats',
      <DeploymentUsageBasedPlanFeatureTextWithTooltip planType="startup" />,
      `${xCount(
        'Dev deployment',
        PAYMENT_PLAN_PRICING_MAP['startup'].lgpDevDeployments || 0
      )} with usage included`,
    ],
    planPriceHead: `$${PAYMENT_PLAN_PRICING_MAP['startup'].pricePerSeat}`,
    planPriceDesc: '/ seat per month',
  },
  startup_v0: {
    planDesc: 'For small teams starting to build and deploy agents',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip planType="startup_v0" />,
      'Up to 10 seats',
      <DeploymentUsageBasedPlanFeatureTextWithTooltip planType="startup_v0" />,
      `${xCount(
        'Dev deployment',
        PAYMENT_PLAN_PRICING_MAP['startup_v0'].lgpDevDeployments || 0
      )} with usage included`,
    ],
    planPriceHead: `$${PAYMENT_PLAN_PRICING_MAP['startup_v0'].pricePerSeat}`,
    planPriceDesc: '/ seat per month',
  },
  premier: {
    planDesc: 'For our valued customers',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip planType="premier" />,
      'Up to 10 seats',
      <DeploymentUsageBasedPlanFeatureTextWithTooltip planType="premier" />,
      `${xCount(
        'Dev deployment',
        PAYMENT_PLAN_PRICING_MAP['premier'].lgpDevDeployments || 0
      )} with usage included`,
    ],
    planPriceHead: `$${PAYMENT_PLAN_PRICING_MAP['premier'].pricePerSeat}`,
    planPriceDesc: '/ seat per month',
  },
  partner: {
    planDesc: 'For our valued partners',
    planFeatures: [
      <TraceUsageBasedPlanFeatureTextWithTooltip planType="partner" />,
      'Up to 10 seats',
      <DeploymentUsageBasedPlanFeatureTextWithTooltip planType="partner" />,
      `${xCount(
        'Dev deployment',
        PAYMENT_PLAN_PRICING_MAP['partner'].lgpDevDeployments || 0
      )} with usage included`,
    ],
    planPriceHead: `$${PAYMENT_PLAN_PRICING_MAP['partner'].pricePerSeat}`,
    planPriceDesc: '/ seat per month',
  },
  applyEnterprise: {
    planDesc: 'For teams with advanced deployment, security, and support needs',
    planFeatures: [
      'Deployment options including hybrid and self-hosted',
      'Custom SSO and RBAC',
      'Guaranteed support SLA',
      'Access to deployed engineering team',
      'Team trainings and architectural guidance',
    ],
    planPriceHead: 'Custom',
    planPriceDesc: '',
  },
};
